export default "__VITE_ASSET__g_T6Y32Z__"